import React from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import PropTypes from 'prop-types';
import { Button, Alert } from 'antd';

import Input from '../../components/form/Input';
import { required, validatePassword } from '../../components/form/validation';

import s from './profile.less';

class Profile extends React.Component {
  static propTypes = {
    error: PropTypes.any,
  };
  state = {
    success: false,
  };

  submit = async values => {
    if (values.password !== values.passwordRepeat)
      throw new SubmissionError({
        passwordRepeat: 'Repeated password not matches password',
      });
    try {
      await fetch('/customer/password', { method: 'post', body: values });
    } catch (e) {
      throw new SubmissionError({ _error: e.error });
    }
    this.setState({ success: true });
  };
  render() {
    return (
      <div>
        <form
          onSubmit={this.props.handleSubmit(this.submit)}
          className={s.form}
        >
          <Field
            placeholder="Password"
            name="password"
            component={Input}
            type="password"
            validate={[required, validatePassword]}
          />
          <Field
            placeholder="Repeat password"
            name="passwordRepeat"
            component={Input}
            type="password"
            validate={required}
          />
          <Button htmlType="submit" type="primary">
            Update
          </Button>
          {this.props.error && (
            <Alert message={this.props.error} type="error" />
          )}
          {this.state.success && (
            <Alert
              message="Password has been changed successfully"
              type="success"
            />
          )}
        </form>
      </div>
    );
  }
}

Profile.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'customer-password',
})(Profile);
